var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEmployeeIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 86.436,
    height: 100.078,
    viewBox: "0 0 86.436 100.078",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "employeeIcon",
    transform: "translate(-747.243 -283.779)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_13850",
    "data-name": "Group 13850",
    transform: "translate(747.749 277.177)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_140",
    "data-name": "Group 140"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Subtraction_3",
    "data-name": "Subtraction 3",
    d: "M-659.074,9224.5h-5.334c-16.353,0-39.826,11.021-39.826,29.482a8.671,8.671,0,0,0,7.681,9.559c.165.018.33.031.5.039h69a8.558,8.558,0,0,0,8.2-8.9c0-.112-.012-.227-.021-.339v-.354C-618.894,9235.521-642.358,9224.5-659.074,9224.5Z",
    transform: "translate(704.285 -9157.399)",
    fill: "rgba(var(--secondaryColorRGB),0.2)",
    stroke: "var(--secondaryColor)",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_51",
    "data-name": "Path 51",
    d: "M792.279,337.168a20.135,20.135,0,0,0,15.287-6.4,45.251,45.251,0,0,0,9.6-29.16,24.895,24.895,0,0,0-49.781,0,46.552,46.552,0,0,0,9.6,29.481A21.19,21.19,0,0,0,792.279,337.168Z",
    transform: "translate(-749.558 -270.075)",
    fill: "rgba(var(--secondaryColorRGB),0.2)",
    stroke: "var(--secondaryColor)",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmployeeIcon);
export default __webpack_public_path__ + "static/media/employeeIcon.0b319e2a827f2128ee5cccd9bfc017ad.svg";
export { ForwardRef as ReactComponent };